/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Language from './components/Language';
import Category from './components/Category';
import ADPStageStatus from './components/AdpStageStatus';
import hindi from '../../../../translations/hn.json';
import spanish from '../../../../translations/es.json';
import english from '../../../../translations/en.json';
import french from '../../../../translations/fr.json';
import german from '../../../../translations/ge.json';
import Training from './components/training';
import Loader from '../../../../components/loading';
import { getApplicationDetails, saveUserData, clearUpdatedDp, fetchSchedules,
  clearDraftState, getAdpApplicationStage, clearApplicationStatus,
  makeAdpPayment, getAdpDefaultFields, getAdpCategories } from '../../redux/action';
import Certificate from '../Components/Certificate';
import Result from '../Components/FailurePage';
import AdpDriverPublicForm from './components/AdpDriverPublicForm';
import PaymentPage from '../Components/PaymentPage';
import Scheduling from './components/Scheduling';
import ApplicationStatus from '../authentication/components/FormStatus';
import PreMessageDisplay from './components/PreMessageDisplay';
import OfflinePayment from '../Components/OfflinePayment';
import TnsPaymentModal from './components/TnsPaymentModal';

export default function StartApplication(props) {
  const { match } = props;
  const id = match?.params?.id;
  const dispatch=useDispatch();
    const [selectedLanguage, setSelectedLanguage] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(false);
    const [adpCategory, setAdpCategory] = useState('');
    const [appData, setAppData] = useState({});
    const [invoiceObject, setInvoiceObject] = useState({});
    const applicationDetails = useSelector(states => states?.permitManagement?.applicationDetails);
    const isPaymentAvailable = useSelector(states => states?.permitManagement?.isPaymentAvailable) || false;
    const isScheduleEnable = useSelector(states => states?.permitManagement?.isScheduleEnable) || false;
    const actionApplicationDetails = useSelector(states => states?.permitManagement?.actionApplicationDetails);
    const adpAppSettings = useSelector(state => state?.permitManagement?.adpDefaultFields);
    const adpCategories = useSelector(state => state?.permitManagement?.adpCategories);
    const adpSchemaSettings = useSelector(state => state.permitManagement?.adpSchemaSettings);
    const paymentActionStatus = useSelector(state => state?.permitManagement?.makeAdpPaymentAction);
    const paymentRedirectUrl = useSelector(state => state?.permitManagement?.paymentRedirectUrl);
    const defaultCurrentStep = (applicationDetails?.application_pre_message?.length > 0
      && applicationDetails?.application_pre_message !== '<p><br></p>') ? 'preMessage' : 'language';
    const [currentStep, setCurrentStep] = useState(JSON.parse(localStorage.getItem(id)||'{}')?.currentStep || defaultCurrentStep);
    const [languages, setLanguages] = useState([]);
    const [translation, setTranslation] = useState(english);
    const [unSuportedLanguage, setUnSuportedLanguage] = useState(false);
    const [categories, setCategories] = useState(false);
    const suportedLanguages = [
      { name: 'hindi', value: hindi },
      { name: 'english', value: english },
      { name: 'spanish', value: spanish },
      { name: 'french', value: french },
      { name: 'german', value: german }
    ];
    const [certificateUrl, setCertificateUrl] = useState(JSON.parse(localStorage.getItem(id)||'{}')?.certificateUrl|| '');
    const [actualAttempts, setActualAttempts] = useState(1);
    const [reAttemptQuiz, setReAttemptQuiz] = useState(false);
    const [quizAnswers, setQuizAnswers] = useState({});
    const [tnsPaymentUrl, handleTnsPaymentUrl] = useState('');
    const user = useSelector(state => state.auth.profile);
    const steps = ['language', 'category', 'training', 'quiz', 'certificate', 'application', 'payment', 'scheduling'];
    const isTnsPaymentTrackingEnable = user?.portal_airport?.airport_settings?.payment_tracking === 'TNS';

    useEffect(() => {
      dispatch(getApplicationDetails(id));
      dispatch(getAdpCategories(true));
      dispatch(clearUpdatedDp());
      dispatch(fetchSchedules());
      dispatch(getAdpDefaultFields());
    }, [id]);

  const initialRenderRef1 = useRef(true);
  const initialRenderRef2 = useRef(false);

  useEffect(() => {
    if (initialRenderRef1.current && actionApplicationDetails?.success) {
      const localData = JSON.parse(localStorage.getItem(id) || '{}');
      const apiData = applicationDetails?.permit?.meta_data?.application_meta || {};

      if (((Object.keys(applicationDetails?.permit?.meta_data || {}).length > 0 && Object.keys(apiData).length > 0)
    || Object.keys(localData || {})?.length > 0)) {
        const merged = {
          ...apiData,
          selectedLanguage: apiData.selectedLanguage || localData.selectedLanguage || selectedLanguage,
          translation: apiData.translation || localData.translation || translation,
          currentStep: apiData.currentStep || localData.currentStep || defaultCurrentStep,
          selectedCategory: apiData.selectedCategory || localData.selectedCategory || selectedCategory,
          certificateUrl: apiData.certificateUrl || localData.certificateUrl || certificateUrl
        };
        localStorage.setItem(id, JSON.stringify(merged));
      } else {
        setCurrentStep(defaultCurrentStep);
        localStorage.setItem(id, JSON.stringify({
          selectedLanguage,
          translation,
          currentStep: defaultCurrentStep,
          selectedCategory,
          certificateUrl
        }));
      }
      initialRenderRef1.current = false;
      initialRenderRef2.current = true;
      dispatch(clearApplicationStatus());
    }
  }, [actionApplicationDetails, applicationDetails]);

  useEffect(() => {
    if (initialRenderRef2.current) {
      const localData = JSON.parse(localStorage.getItem(id) || '{}');
      const updated = {
        ...localData,
        selectedLanguage: localData.selectedLanguage || selectedLanguage,
        translation: localData.translation || translation,
        currentStep: localData.currentStep,
        selectedCategory: localData.selectedCategory || selectedCategory,
        certificateUrl: localData.certificateUrl || certificateUrl
      };
      setSelectedLanguage(updated.selectedLanguage);
      setTranslation(updated.translation);
      setCurrentStep(updated.currentStep);
      setSelectedCategory(updated.selectedCategory);
      setCertificateUrl(updated.certificateUrl);
      localStorage.setItem(id, JSON.stringify(updated));
      initialRenderRef2.current = false;
    }
  }, [initialRenderRef2.current]);

  useEffect(() => {
    if (!initialRenderRef1.current && !initialRenderRef2.current) {
      const localData = JSON.parse(localStorage.getItem(id) || '{}');
      const updated = {
        ...localData,
        selectedLanguage: selectedLanguage || localData.selectedLanguage,
        translation: translation || localData.translation,
        currentStep,
        selectedCategory: selectedCategory || localData.selectedCategory,
        certificateUrl: certificateUrl || localData.certificateUrl
      };
      localStorage.setItem(id, JSON.stringify(updated));
      setAppData(adpAppSettings);
    }
  }, [translation, currentStep, certificateUrl, selectedLanguage, selectedCategory, adpAppSettings]);

  useEffect(() => {
    const details = localStorage.getItem(id);
    if (details) {
      const data = JSON.parse(details);
      setSelectedLanguage(data.selectedLanguage);
      setTranslation(data.translation);
      if (selectedCategory || data?.selectedCategory) {
        setSelectedCategory(selectedCategory || data?.selectedCategory);
      }
      if (data?.currentStep === 'certificate' && data?.certificateUrl) {
          setCertificateUrl(data?.certificateUrl);
      } else {
        setCurrentStep(data.currentStep);
      }
    }
  }, [id]);

  useEffect(() => {
    if (['training', 'quiz', 'certificate'].includes(currentStep) && certificateUrl?.length > 0) {
      setCurrentStep('certificate');
    } else if ((currentStep === 'training' || currentStep === 'language') && (
        applicationDetails?.permit?.offline_training
        || applicationDetails?.disable_driver_permit_online_training
        || [1, 14].includes(applicationDetails?.permit?.status))) {
      setCurrentStep('application');
    } else if (currentStep === 'completed') {
      localStorage.removeItem(id);
    }
  }, [applicationDetails, currentStep]);

  useEffect(() => {
    if (applicationDetails?.lms) {
      setLanguages(Object.keys(applicationDetails?.lms));
    }
    if (applicationDetails?.permit?.category_of_adp) {
      setAdpCategory(applicationDetails?.permit?.category_of_adp);
    }
    dispatch(saveUserData(applicationDetails));
  }, [applicationDetails]);

  useEffect(() => {
    const interval = setInterval(() => {
      const meta = localStorage.getItem(id);
      const data = meta ? JSON.parse(meta) : null;
      if (data
          && !['application', 'payment', 'scheduling', 'completed'].includes(data?.currentStep)) {
        dispatch(getAdpApplicationStage(id, data));
      }
    }, 90000);
    return () => clearInterval(interval);
  }, [id]);

  useEffect(() => () => {
    const data = localStorage.getItem(id);
    if (data) {
      const parsed = JSON.parse(data);
      if (parsed?.currentStep === 'category' && !parsed?.selectedCategory
        || parsed?.currentStep === 'training' && !parsed?.selectedCategory
        || parsed?.currentStep === 'language') {
        parsed.currentStep = 'language';
        parsed.selectedLanguage = false;
      }
      dispatch(getAdpApplicationStage(id, {
        ...applicationDetails?.permit?.meta_data?.application_meta, ...parsed
      }));
      localStorage.setItem(id, JSON.stringify({
        ...applicationDetails?.permit?.meta_data?.application_meta, ...parsed }));
      }
    dispatch(clearDraftState());
  }, []);

  const handellanguage = (value) => {
    const localData = JSON.parse(localStorage.getItem(id) || '{}');
    let index = '';
    let localUnSuportedLanguage = false;
    suportedLanguages.forEach((ele, i) => {
      if (value === String(ele.name)) {
        setTranslation(ele.value);
        index = i;
        localUnSuportedLanguage = true;
      }
    });
    if (!localUnSuportedLanguage) {
      setTranslation(english);
      setUnSuportedLanguage(true);
      dispatch(getAdpApplicationStage(id, { ...localData, adpLanguage: english }));
      localStorage.setItem('adpLanguage', JSON.stringify(english));
      localStorage.setItem(id, JSON.stringify({ ...localData, adpLanguage: english }));
      setSelectedLanguage('english');
    } else {
      dispatch(getAdpApplicationStage(id, { ...localData, adpLanguage: suportedLanguages[index] }));
      localStorage.setItem('adpLanguage', JSON.stringify(suportedLanguages[index]));
      localStorage.setItem(id, JSON.stringify({ ...localData, adpLanguage: suportedLanguages[index] }));
      setSelectedLanguage(value);
    }
    if (applicationDetails?.enable_category_training) {
      const categoryData = Object.keys(applicationDetails?.category_trainings || {}).length === 1
          ? applicationDetails?.category_trainings[
              Object.keys(applicationDetails?.category_trainings)?.[0]
            ]
          : applicationDetails?.category_trainings?.[value];
          const allCategories = Object.keys(categoryData||{});
      setCategories(allCategories);
    }
  };

  const handleQuizAnswers = (answer) => {
    setQuizAnswers(answer);
  };


  const handlePrev = () => {
    setCurrentStep(steps?.[steps.findIndex(step => step === currentStep) - 1]);
  };

  const handleCategory = (i) => {
    setSelectedCategory(i);
  };

  const saveCertificate=(url) => {
    setCertificateUrl(url);
  };

  const changePage = (currentPage, currentStepper) => {
    // IF Disable Training and Quiz SETTINGS IS ON - GO TO APPLICATION AFTER SELECTING LANGUAGE AND CATEGORY
    if (applicationDetails?.disable_driver_permit_online_training && currentStepper === 'training') {
      setCurrentStep('application');
    } else {
      setCurrentStep(currentStepper);
    }
  };
  const handelNavigation = async (path, current_Stepper, status) => {
    const no_of_reattempts = Number(
        applicationDetails?.lms?.English?.sections?.[0]?.additional_config
          ?.no_of_quiz_reattempts
      )+1 || 1;
    if (
      path === 'training'
      && current_Stepper === 'training'
      && actualAttempts + 1 <= no_of_reattempts
    ) {
      setActualAttempts(actualAttempts + 1);
    } else if (path === 'training' && current_Stepper === 'training') {
      setActualAttempts(1);
    }
    if (path === 'scheduling' && current_Stepper === 'scheduling' && isScheduleEnable) {
      setCurrentStep('scheduling');
    }
    if (path === 'scheduling' && current_Stepper === 'scheduling' && !isScheduleEnable) {
      setCurrentStep('completed');
    }
    if (status === 'fail') {
      setReAttemptQuiz(true);
      clearUpdatedDp();
      localStorage.removeItem(id);
      setCurrentStep('training');
    }
  };

  useEffect(() => {
    if (currentStep === 'payment'&& (paymentActionStatus?.success || paymentActionStatus?.error)) {
      if (paymentActionStatus?.success && paymentRedirectUrl && isTnsPaymentTrackingEnable) {
        handleTnsPaymentUrl(paymentRedirectUrl);
        changePage('payment', 'payment');
        return;
      }
      if (isScheduleEnable) {
        changePage('scheduling', 'scheduling');
      } else {
        changePage('completed', 'completed');
      }
    }
  }, [paymentActionStatus, dispatch]);

  const handlePayment = useCallback((tokenDetails, payment_value) => {
    if (tokenDetails) {
      let payload = {
        payment_info: {
          id: tokenDetails?.token?.id || null,
          amount: payment_value || 0,
          description: invoiceObject?.description || '',
          fee_type: invoiceObject?.fee_type,
          other_info: {
            ...invoiceObject,
            currency: user?.portal_airport?.airport_settings?.currency || '$'
          },
          payment_by_tenant: adpSchemaSettings?.adp_payment_type_for_tenant === 'offline'
        }
      };
      if (Number(payment_value) === 0) {
        payload.skip_payment = true;
      }
      dispatch(makeAdpPayment(id, payload));
    }
  }, [adpSchemaSettings, dispatch, invoiceObject, id, user?.portal_airport?.airport_settings?.currency]);

  const handleOfflinePayment = useCallback((tokenDetails, payment_value) => {
    handlePayment(tokenDetails, payment_value);
  }, [handlePayment]);

  let component;
  if (currentStep === 'preMessage') {
    component = <PreMessageDisplay
      handelNext={changePage}
      userData={applicationDetails}
    />;
  } else if (currentStep === 'language') {
    component = <Language
      handelLanguage={handellanguage}
      selectedLanguage={selectedLanguage}
      handelNext={changePage}
      category={adpCategory}
      languages={applicationDetails?.enable_category_training? Object.keys(applicationDetails?.category_trainings||{}) : languages}
    />;
  } else if (currentStep === 'category') {
    component = <Category
      handleCategory={handleCategory}
      selectedCategory={selectedCategory}
      handelNext={changePage}
      handelPrev={handlePrev}
      categories={categories}
      adpCategory={adpCategory}
      adpCategories={adpCategories}
    />;
  } else if (currentStep === 'training' || currentStep === 'quiz') {
    component = <Training
      ismyapplication
      myapplication={applicationDetails}
      currentStepper={currentStep}
      changeStepper={setCurrentStep}
      saveCertificate={saveCertificate}
      navigateTo={handelNavigation}
      translation={selectedLanguage}
      suportedLanguages={suportedLanguages}
      unSuportedLanguage={undefined}
      handleGetAdpData={() => {}}
      currentAttempts={1}
      selectedCategory={selectedCategory}
      handleQuizAnswers={handleQuizAnswers}
      orderId={id}
      reAttemptQuiz={reAttemptQuiz}
      setCurrentStep={setCurrentStep}
      setReAttemptQuiz={setReAttemptQuiz}
      userTrainingDataAction={{
        success: false,
        error: false,
        loading: false
      }}
    />;
  } else if (currentStep === 'certificate') {
    component = <>
      {certificateUrl ? <Certificate
      navigateToApplication={() => {
        setCurrentStep('application');
      }}
      certificateUrl={certificateUrl}
      applicationDetails={applicationDetails}
      translation={translation}
      suportedLanguages={suportedLanguages}
      unSuportedLanguage={unSuportedLanguage}
      quizAnswers={quizAnswers}
      isPortal
      installationId={match?.params?.installationId}
      {...props}
    />: <Result
    handelNavigation={handelNavigation}
    applicationDetails={applicationDetails}
    translation={translation}
    selectedCategory={selectedCategory}
    suportedLanguages={suportedLanguages}
    isPortal
    enable_category_training={applicationDetails?.enable_category_training}
    {...props}
  />}
                </>;
  } else if (currentStep === 'application') {
    component = <AdpDriverPublicForm
    changePage={changePage}
    applicationDetails={applicationDetails}
    selectedCategory={selectedCategory}
    translation={translation}
    orderId={id}
    match={match}
    isPaymentAvailable={isPaymentAvailable}
    handleSaveCategoryFee={invoice => setInvoiceObject(invoice)}
    adpAppSettings={adpAppSettings}
    adpSchemaSettings={adpSchemaSettings}

    />;
  } else if (currentStep === 'payment') {
    component = (
    <div className="d-flex justify-content-center">
      {adpSchemaSettings?.adp_payment_type_for_tenant === 'online' && !isTnsPaymentTrackingEnable
        && invoiceObject?.grandTotal > 0
        ? <PaymentPage
          user={user}
          paymentData={invoiceObject?.grandTotal || 0}
          profileCurrency={
            user?.portal_airport?.airport_settings?.currency || '$'
          }
          handlePayment={handlePayment}
          handelNavigation={handelNavigation}
          statusBar={applicationDetails.disable_driver_permit_online_training}
          airportSettings={user?.portal_airport?.airport_settings}
          handleGetApplicationDetails={() => dispatch(getApplicationDetails(id))}
          paymentModule="driver_permit"
        />
  : (
  <>
    <OfflinePayment handlePayment={handleOfflinePayment} paymentData={invoiceObject?.grandTotal || 0} />
  </>)}
    </div>
  );
  } else if (currentStep === 'scheduling') {
    component = <div className="d-flex flex-column align-items-center"><Scheduling
    changePage={changePage}
    id={id}
    Uichange={applicationDetails?.disable_driver_permit_online_training}
  />
                </div>;
  } else if (currentStep === 'completed') {
    component = <ApplicationStatus userData={appData?.settings_required_for_public} />;
  }
  if (tnsPaymentUrl) {
    component = (
      <TnsPaymentModal
        tnsPaymentUrl={tnsPaymentUrl}
        onClosePaymentModal={() => handleTnsPaymentUrl('')}
        tnsPaymentModal={false}
        tnsPaymentMessages={false}
      />
    );
  }

  return (
    <div>
      <Loader loadingStatus={actionApplicationDetails.loading || paymentActionStatus?.loading} />
      <ADPStageStatus current_stage={currentStep} translation={translation} userData={applicationDetails}
        scheduleEnable={applicationDetails?.scheduleEnable}
        calendarVisibility
        isPaymentAvailable={isPaymentAvailable}
      />
      {component}
    </div>
  );
}
